import React, { FC, PropsWithChildren } from 'react';
import { Icon } from '@iconify/react';
import { Box, Typography } from '@mui/material';
import { CustomLayout } from 'src/sections/layouts/custom-layout';

interface UnderConstructionProps {}

export const UnderConstruction: FC<
  PropsWithChildren<UnderConstructionProps>
> = (props) => {
  const { children } = props;

  // show development content in development mode
  if (import.meta.env.DEV && children) return <>{children}</>;

  // otherwise show under construction page
  return (
    <CustomLayout
      maxWidth="sm"
      stackProps={{ alignItems: 'center' }}
      boxProps={{ display: 'flex', flexGrow: 1 }}
      sx={{ display: 'flex', flexGrow: 1 }}
    >
      <Box flexGrow={1} />
      <Icon
        icon="fa6-solid:person-digging"
        style={{ fontSize: '96px', opacity: 0.8 }}
      />
      <Typography variant="body1">
        Diese Seite befindet sich gerade noch in der Entwicklung...
      </Typography>
      <Box flexGrow={1} />
    </CustomLayout>
  );
};
